import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import style from "./index.module.scss";

const exclusionKeys = [
  "glass",
  "cars",
  "alcoholAndTobacco",
  "fruitAndVegetables",
  "fuelAndChemicals",
  "ammunition",
  "drinks",
];

const InsuranceExclusionsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const title = t("cargoInsurance.exclusionsTitle");

  return ReactDOM.createPortal(
    <div className={style.exclusionsOverlay} onClick={onClose}>
      <div
        className={style.exclusionsModal}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={style.exclusionsModal_header}>
          <h2>{title}</h2>
          <button
            type="button"
            className={style.exclusionsModal_close}
            onClick={onClose}
            aria-label={t("common.close")}
          >
            <CloseIconNew fill="#212121" />
          </button>
        </div>

        <ol className={style.exclusionsModal_list}>
          {exclusionKeys.map((key, index) => (
            <li key={key}>
              <span className={style.exclusionsModal_listNumber}>{index + 1}.</span>
              <span className={style.exclusionsModal_listText}>
                {t(`cargoInsurance.exclusions.${key}`)}
              </span>
            </li>
          ))}
        </ol>

        <div className={style.exclusionsModal_limit}>
          <span>{t("cargoInsurance.cargoValueLimit")}</span>
          <strong>50 000 000 ₸</strong>
          <span>{t("cargoInsurance.perTransportation")}</span>
        </div>

        <button type="button" className={style.exclusionsModal_confirm} onClick={onClose}>
          {t("cargoInsurance.understood")}
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default InsuranceExclusionsModal;
